import { removeDupes } from '../utils/helpers';

const projects = (state = {
    items: [],
    fetched: false,
    error: false,
    loading: true,
    shouldRefetch: false
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
            return {
                items: [],
                fetched: false,
                error: false,
                loading: true
            };

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                shouldRefetch: true
            });

        case 'PROJECTS_FETCH_REQUESTED':
            if (action.payload && action.payload.archived) {
                return state;
            }

            return Object.assign({}, state, {
                error: false,
                loading: true,
                shouldRefetch: false
            });

        case 'PROJECTS_FETCH_FAILED':
            if (action.payload.archived) {
                return state;
            }

            return Object.assign({}, state, {
                loading: false,
                fetched: true,
                error: action.payload.message || true
            });

        case 'PROJECTS_FETCH_SUCCEEDED':
            if (!action.payload || !action.payload.projects) {
                return state;
            }

            if (action.payload.archived) {
                return Object.assign({}, state, {
                    items: removeDupes([...state.items, ...action.payload.projects])
                });
            }

            return Object.assign({}, state, {
                items: removeDupes([...state.items, ...action.payload.projects]),
                loading: false,
                fetched: true,
                error: false
            });

        case 'PROJECT_CREATE_REQUESTED':
        case 'PROJECT_ADD_SOCKET':
            if (action.payload.project.customTemplate) {
                return state;
            }

            return Object.assign({}, state, {
                items: removeDupes([...state.items, action.payload.project])
            });

        case 'PROJECT_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(project => project !== action.payload.fragment)
            });

        case 'PROJECT_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items
                    .filter(project => project.id !== action.payload.projectId)
                    .map(project => {
                        if (project === action.payload.fragment) {
                            return Object.assign({}, project, action.payload.project);
                        }

                        return project;
                    })
            });

        case 'PROJECT_FETCH_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items.filter(project => project.id !== action.payload.projectId), {
                    id: action.payload.projectId,
                    loading: true
                }]
            });

        case 'PROJECT_FETCH_FAILED':
            return Object.assign({}, state, {
                items: [...state.items.filter(project => project.id !== action.payload.projectId), {
                    id: action.payload.projectId,
                    error: true
                }]
            });

        case 'PROJECT_FETCH_SUCCEEDED':
            if (!action.payload || !action.payload.project) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items.filter(project => project.id !== action.payload.project.id), action.payload.project]
            });

        case 'PROJECT_UPDATE_REQUESTED':
        case 'PROJECT_UPDATE_SOCKET': {
            const projectProps = {...(action.payload.project || action.payload.projectProps)};

            if (projectProps.logoBase64) {
                projectProps.logo = projectProps.logoBase64;
                projectProps.logoBase64 = undefined;
            }

            if (!state.items.some(project => project?.id === action.payload.projectId)) {
                return Object.assign({}, state, {
                    items: [...state.items, action.payload.project]
                });
            }

            return Object.assign({}, state, {
                items: [...state.items].map(project => {
                    if (project?.id === action.payload.projectId) {
                        return Object.assign({}, project, projectProps);
                    }

                    return project;
                })
            });
        }

        case 'PROJECT_MODULE_ENABLE_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(project => {
                    if (project.id === action.payload.projectId) {
                        return {
                            ...project,
                            disabled_modules: (project.disabled_modules || []).filter(module => module !== action.payload.module)
                        }
                    }

                    return project;
                })
            });

        case 'PROJECT_MODULE_DISABLE_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(project => {
                    if (project.id === action.payload.projectId) {
                        return {
                            ...project,
                            disabled_modules: [...(project.disabled_modules || []), action.payload.module]
                        }
                    }

                    return project;
                })
            });

        case 'PROJECT_REMOVE_REQUESTED':
        case 'PROJECT_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: state.items.filter(project => project.id !== action.payload.projectId)
            });

        case 'PROJECT_JOIN_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(project => {
                    if (project.id === action.payload.projectId) {
                        return Object.assign({}, project, {
                            joined: true
                        });
                    }

                    return project;
                })
            });

        case 'PROJECT_INVITE_USERS_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items.map(project => {
                    if (project.id === action.payload.projectId) {
                        return Object.assign({}, project, {
                            members: [...new Set([...(project.members || []), ...action.payload.users])]
                        });
                    }

                    return project;
                })]
            });

        case 'PROJECT_USER_REMOVE_SOCKET':
        case 'PROJECT_REMOVE_USER_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(project => {
                    if (project.id === action.payload.projectId) {
                        return Object.assign({}, project, {
                            members: (project.members || []).filter(userId => userId !== action.payload.userId),
                            owner: project.owner === action.payload.userId ? null : project.owner
                        });
                    }

                    return project;
                })
            });

        case 'PROJECT_LEAVE_REQUESTED':
        case 'PROJECT_KICK_SOCKET':
            return Object.assign({}, state, {
                items: state.items.filter(project => project.id !== action.payload.projectId)
            });

        case 'SUBTEAM_KICK_SOCKET':
            return Object.assign({}, state, {
                items: state.items.filter(project => project.subteam !== action.payload.subteamId)
            });


        case 'SUBTEAM_REMOVE_REQUESTED':
            if (!action.payload.removeOptions?.projects) {
                return state;
            }

            return Object.assign({}, state, {
                items: state.items.filter(project => project.subteam !== action.payload.subteamId)
            });

        case 'USER_REMOVE_REQUESTED':
        case 'TEAM_USER_REMOVE_SOCKET':
        case 'USER_INVITE_CANCEL_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(project => {
                    if (!action.payload.projectId || action.payload.projectId === project.id) {
                        return Object.assign({}, project, {
                            members: (project.members || []).filter(userId => userId !== action.payload.userId)
                        });
                    }

                    return project;
                })
            });

        case 'DISCUSSION_UPDATE_SOCKET': {
            const project = state.items.find(p => p.general_discussion === action.payload.discussionId);

            if (!project) {
                return state;
            }

            return Object.assign({}, state, {
                items: [...state.items].map(project => {
                    if (project.general_discussion === action.payload.discussionId) {
                        return Object.assign({}, project, {
                            webex_join_url: action.payload.discussion.webex_join_url,
                            zoom_join_url: action.payload.discussion.zoom_join_url,
                            pinned_message: action.payload.discussion.pinned_message,
                            pinned_by: action.payload.discussion.pinned_by
                        });
                    }

                    return project;
                })
            });
        }

    case 'PROJECT_OWNERSHIP_TRANSFER':
            return Object.assign({}, state, {
                items: [...state.items].map(project => {
                    if (project?.id === action.payload.projectId) {
                        return Object.assign({}, project, {
                            owner: action.payload.userId
                        });
                    }

                    return project;
                })
            });


        default:
            return state;
    }
}

export default projects;
